/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Article50_LinkInputs */

const en_about_article50_link = /** @type {(inputs: About_Article50_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Read the AI transparency notice`)
};

const de_about_article50_link = /** @type {(inputs: About_Article50_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Transparenzhinweis lesen`)
};

const fr_about_article50_link = /** @type {(inputs: About_Article50_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lire l’avis de transparence sur l’IA`)
};

const es_about_article50_link = /** @type {(inputs: About_Article50_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leer el aviso de transparencia de IA`)
};

const it_about_article50_link = /** @type {(inputs: About_Article50_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leggi l’avviso sulla trasparenza dell’IA`)
};

const nl_about_article50_link = /** @type {(inputs: About_Article50_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lees de AI-transparantiemelding`)
};

const pl_about_article50_link = /** @type {(inputs: About_Article50_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przeczytaj informację o przejrzystości AI`)
};

const fi_about_article50_link = /** @type {(inputs: About_Article50_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lue tekoälyn läpinäkyvyysilmoitus`)
};

const da_about_article50_link = /** @type {(inputs: About_Article50_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Læs AI-gennemsigtighedsmeddelelsen`)
};

const sv_about_article50_link = /** @type {(inputs: About_Article50_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Läs meddelandet om AI-transparens`)
};

/**
* | output |
* | --- |
* | "Read the AI transparency notice" |
*
* @param {About_Article50_LinkInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const about_article50_link = /** @type {((inputs?: About_Article50_LinkInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Article50_LinkInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_about_article50_link(inputs)
	if (locale === "fr") return fr_about_article50_link(inputs)
	if (locale === "es") return es_about_article50_link(inputs)
	if (locale === "it") return it_about_article50_link(inputs)
	if (locale === "nl") return nl_about_article50_link(inputs)
	if (locale === "pl") return pl_about_article50_link(inputs)
	if (locale === "fi") return fi_about_article50_link(inputs)
	if (locale === "da") return da_about_article50_link(inputs)
	if (locale === "sv") return sv_about_article50_link(inputs)
	return en_about_article50_link(inputs)
});